import React, { useState } from "react";
import { Box, Link, Typography, Button } from "@mui/material";
import { IoIosArrowUp ,IoIosArrowDown } from "react-icons/io";

const Cards = ({ title, description, image, buttonText, buttonTextUrl, displayImage }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Box
      className="cardBox vendor-card-wraper"
      sx={{
        height:"80%",
        display: "flex",
        // justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        mb: 2,
        border: "1px solid rgba(0, 0, 0, 0.21)",
        borderRadius: "15px",
        background: "#fff",
        marginBottom: '0',
        padding: '15px',
        "& img": {
          display: "block",
          maxWidth: "100%",
          width: '300px',
          height: '100%',
          objectFit: "contain",
        },
      }}
    >
      <Box>
        {
          displayImage &&
          <div className="vendor-box-img">
            <img src={image} alt="Vendor-Logo" />
          </div>
        }

      </Box>
      <Typography
        variant="h4"
        sx={{
          fontFamily: `"Quicksand", sans-serif`,
          fontWeight: 700,
          lineHeight: "28.8px",
          fontSize: { xs: "16px", md: "22px", lg: "24px" },
          color: "#253D4E",
          textAlign: "center",
        }}
      >
        {title}
      </Typography>
      <Box mt={1}>
        {
          !displayImage &&
          <Typography
            sx={{
              fontWeight: 400,
              lineHeight: "24px",
              fontSize: { xs: "16px", md: "16px", lg: "17px" },
              color: "#7E7E7E",
              // whiteSpace: expanded ? "pre-line" : "normal",
              // display: "-webkit-box",
              // WebkitLineClamp: expanded ? "none" : 2,
              // WebkitBoxOrient: "vertical",
              // overflow: "hidden",
              margin: "15px 0",
              textAlign: 'center',
            }}
          >
            {description}
          </Typography>
        }


        {/* {!displayImage && description?.length > 100 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "end",
            }}>
            <Button
              onClick={() => setExpanded(!expanded)}
              size="small"
              sx={{
                color: "#fff",
                fontWeight: 500,
                textTransform: "none",
                display: "flex",
                justifyContent: "end",
                alignItems: "end",
                gap: "4px",
                backgroundColor: "#008BFF",
              }}
            >
              {expanded ? (
                <>
                  Show less <IoIosArrowUp  fontSize="small" />
                </>
              ) : (
                <>
                  Read more <IoIosArrowDown fontSize="small" />
                </>
              )}
            </Button>
          </Box>
        )} */}
      </Box>
      {/* <Link
        size="large"
        variant="contained"
        to={buttonTextUrl}
        sx={{
          color: "#008BFF",
          fontFamily: `"Lato", sans-serif`,
          fontWeight: 400,
          lineHeight: "24px",
          fontSize: { xs: "12px", md: "16px", lg: "16px" },
          textTransform: "capitalize",
          cursor: "pointer",
          "&:hover": {
            color: "#253D4E",
          },
        }}
      >
        {buttonText}
      </Link> */}
    </Box>
  );
};

export default Cards;
